<div class="modal-header modal-pepsico-header">

    @if(Exhibicion(challenge())){
        <h1 class="modal-title fs-5" id="exampleModalLabel">Exhibiciones</h1>
      }@else {
        <h1 class="modal-title fs-5" id="exampleModalLabel"> {{ challenge().name| uppercase }}</h1>
      }
</div>
<div class="modal-body">

    <div class="modal-body">
        @if (!isPermanent) {
        <div class="comment-reactions-tabs-unique">
            <span>
                <b>Fecha de lanzamiento {{challenge().releaseDate |formatDate:'DD/MM/YY' }}</b><br>
                <b>Vigencia {{challenge().validityDate | formatDate:'DD/MM/YY' }}</b>
            </span>
        </div>
    }
        <p class="mt-3">
            {{challenge().mechanics}}
        </p>
        <!-- <a href="politicas.html">Politícas</a> -->
        <img [src]="imgSrc(challenge())" alt="" class="img-info-mis mt-3">
        <div class="order-tracking-unique">
            <div class="d-flex jf-center">
                <button type="button" class="btn btn-primary perfilbtn-pep hw-modal-par" (click)="close()">
                    Cerrar
                  </button>
            
                  <button type="button" class="btn btn-primary perfilbtn-pep hw-modal-par" (click)="participate()"
                  [disabled]="!canParticipate(challenge())">
                    Participar
                  </button>
            </div>
        </div>
    </div>


</div>